export function formatDate(string) {
  if (string === null) {
    return 'N/A';
  }
  const options: {} = { year: 'numeric', month: 'long', day: 'numeric' };
  return new Date(string).toLocaleDateString([], options);
}

export function formatDateShort(string) {
  if (string === null) {
    return 'N/A';
  }
  const options: {} = { year: 'numeric', month: 'short', day: 'numeric' };
  return new Date(string).toLocaleDateString([], options);
}

export function formatDateTime(string) {
  if (string === null) {
    return 'N/A';
  }
  const options: {} = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' };
  return new Date(string).toLocaleString(undefined, options).toLowerCase().replace(',', '');
}

export function getMonthDayYear() {
  const currentDate = new Date();
  const month = currentDate.getMonth() + 1; // Months are zero-based, so add 1
  const day = currentDate.getDate();
  const year = currentDate.getFullYear();
  const formattedTimestamp = `${month}/${day}/${year}`;
  return formattedTimestamp;
};
/**
 * Formats a date in mm/dd/yyyy format with no leading 0s. 
 * @param string 
 * @returns 
 */
export function formatMonthDayYear(string) {
  const result = new Date(string).toLocaleDateString('en-US')
  return result;
};

/**
 * Formats a date in mm/dd/yyyy format with no leading 0s. 
 * Handles date interpretation errors in the case the date string is passed in yyyy-mm-dd format with optional time.
 * @param string 
 * @returns A date string in mm/dd/yyyy format.
 */
export function formatMonthDayYear2(string: string) {
  if (string.includes('T')) {
    string = string.split('T')[0];
  }
  if (string.includes('-')) {
    const parts = string.split('-');
    const year = parts.shift();
    if (parts.length === 0 || year === undefined) {
      return formatMonthDayYear(string);
    }
    parts.push(year);
    const alteredDate = parts.join('/');
    return formatMonthDayYear(alteredDate);
  }
  else {
    return formatMonthDayYear(string);
  }
}